import React from 'react';
import styled from 'styled-components';
import ScrollReveal from './shared/ScrollReveal';

const Section = styled.section`
  padding: 96px 24px;
  max-width: 960px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 64px 16px;
  }
`;

const Header = styled.div`
  margin-bottom: 64px;

  @media (max-width: 768px) {
    margin-bottom: 48px;
  }
`;

const SectionLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${p => p.theme.accent};
  margin-bottom: 16px;
`;

const SectionTitle = styled.h2`
  font-size: 40px;
  font-weight: 600;
  color: ${p => p.theme.text};
  letter-spacing: -0.03em;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

const Steps = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

const Step = styled.div`
  display: grid;
  grid-template-columns: 56px 1fr;
  gap: 24px;
  padding: 32px 0;
  border-top: 1px solid var(--tz-wash, rgba(255, 255, 255, 0.04));

  &:last-child {
    border-bottom: 1px solid var(--tz-wash, rgba(255, 255, 255, 0.04));
  }

  @media (max-width: 640px) {
    grid-template-columns: 40px 1fr;
    gap: 16px;
    padding: 24px 0;
  }
`;

const StepNum = styled.div`
  font-family: ${p => p.theme.fontMono};
  font-size: 14px;
  color: ${p => p.theme.textTertiary};
  padding-top: 2px;
`;

const StepBody = styled.div``;

const StepTitle = styled.h3`
  font-size: 20px;
  font-weight: 500;
  color: ${p => p.theme.text};
  margin-bottom: 8px;
  letter-spacing: -0.01em;
`;

const StepDesc = styled.p`
  font-size: 15px;
  line-height: 1.6;
  color: ${p => p.theme.textSecondary};
  max-width: 480px;
`;

const STEPS = [
  {
    num: '01',
    title: 'Connect your account',
    desc: 'Add TezLab as an MCP server in Claude, ChatGPT, Cursor, or any compatible client. Authorize via OAuth — takes about 30 seconds.',
  },
  {
    num: '02',
    title: 'Ask in plain English',
    desc: 'Query your vehicle data naturally. Charging costs, battery health, trip history, efficiency trends — anything TezLab tracks.',
  },
  {
    num: '03',
    title: 'Act on it',
    desc: 'Send commands to your Tesla — lock, unlock, climate, charging. Write actions are clearly labeled and require confirmation from your MCP client.',
  },
];

export default function HowItWorks() {
  return (
    <Section>
      <ScrollReveal>
        <Header>
          <SectionLabel>How it works</SectionLabel>
          <SectionTitle>Three steps to get started</SectionTitle>
        </Header>
      </ScrollReveal>
      <Steps>
        {STEPS.map((s, i) => (
          <ScrollReveal key={s.num} delay={`${i * 0.08}s`}>
            <Step>
              <StepNum>{s.num}</StepNum>
              <StepBody>
                <StepTitle>{s.title}</StepTitle>
                <StepDesc>{s.desc}</StepDesc>
              </StepBody>
            </Step>
          </ScrollReveal>
        ))}
      </Steps>
    </Section>
  );
}
